// extracted by mini-css-extract-plugin
export default {"tabs":"W6-z","tablist":"X6-z","tablistItem":"Y6-z"};